import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Typography, Box, IconButton, Stack, Grid2 as Grid, Divider
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import moment from "moment";

const RequestInvoiceDetailModal = ({ open, handleClose, data }) => {
  if (!data) return null;

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="h6">
            Detalle de Solicitud de Factura
          </Typography>
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent dividers>
        <Box sx={{ py: 1 }}>
          <Grid container spacing={2}>
            <Grid size={12}>
              <Typography variant="subtitle2">Fecha de solicitud</Typography>
              <Typography variant="body1">{moment(data.date).format("DD/MM/YYYY HH:mm")}</Typography>
            </Grid>
            <Grid size={12}>
              <Divider />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <Typography variant="subtitle2">RFC</Typography>
              <Typography variant="body1">{data.rfc || 'N/A'}</Typography>
            </Grid>
            <Grid size={12}>
              <Typography variant="subtitle2">Razón Social / Nombre</Typography>
              <Typography variant="body1">{data.razon_social || 'N/A'}</Typography>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <Typography variant="subtitle2">Código Postal</Typography>
              <Typography variant="body1">{data.direccion_fiscal?.cp || data.codigo_postal || 'N/A'}</Typography>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <Typography variant="subtitle2">Monto Total</Typography>
              <Typography variant="body1">
                ${data.monto ? data.monto.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00'}
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={handleClose} variant="contained" color="primary">
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RequestInvoiceDetailModal;
